import { Form, Input, Select } from "antd";
import { useState } from "react";
import { ReactComponent as CheckSelectIcon } from "../../../../../common/images/svg/CheckSelect.svg";
import { ReactComponent as ArrowIcon } from "../../../../../common/images/svg/SuffixSelectIcon.svg";
import { addressRules, nameRules } from "../../../../../utils/form.constants";

const FormBankAddNew = ({
  metadataCountries,
}: {
  metadataCountries: {
    value: string;
    label: string;
  }[];
}) => {
  const [searchCountry, setSearchCountry] = useState<string>("");

  const handleChangeCountry = (value: string) => {
    setSearchCountry(value);
  };
  return (
    <>
      <Form.Item
        label="Bank Name"
        name="bankName"
        validateTrigger="onBlur"
        rules={nameRules}
      >
        <Input placeholder="Enter the full name of the bank" />
      </Form.Item>
      <Form.Item
        label="Bank Swift"
        name="bankSwift"
        validateTrigger="onBlur"
        rules={[
          { required: true, message: "This field is required" },
          {
            max: 30,
            message: "Maximum 30 characters",
            validateTrigger: "onChange",
          },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (!/^[A-Z0-9]+$/.test(value)) {
                return Promise.reject("Uppercase letters and numbers only");
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input placeholder="Enter the bank’s SWIFT code for international transfers" />
      </Form.Item>
      <Form.Item
        label="Bank Address"
        name="bankAddress"
        validateTrigger="onBlur"
        rules={addressRules}
      >
        <Input placeholder="Enter the registered address or headquarters of the bank" />
      </Form.Item>
      <Form.Item
        style={{ width: "100%" }}
        label="Bank Country"
        name="bankCountry"
        validateTrigger="onBlur"
        rules={[
          {
            required: true,
            message: "This field is required",
          },
        ]}
      >
        <Select
          showSearch
          style={{ width: "100%" }}
          placeholder="Select the country where the bank is located"
          suffixIcon={<ArrowIcon />}
          onChange={handleChangeCountry}
          optionLabelProp="label"
          filterOption={(input, option) => {
            const label = option?.label;
            if (typeof label === "string") {
              return label.toLowerCase().includes(input.toLowerCase());
            }
            return false;
          }}
        >
          {metadataCountries.map((item) => (
            <Select.Option
              key={item.value}
              value={item.value}
              label={item.label}
            >
              <span
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: 2,
                }}
              >
                <span
                  className="ant-select-custom-value "
                  style={{ whiteSpace: "nowrap" }}
                >
                  {item.label}
                </span>
                {searchCountry === item.value && (
                  <CheckSelectIcon style={{ flexShrink: 0 }} />
                )}
              </span>
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default FormBankAddNew;
